module.exports = __webpack_public_path__ + "static/media/kz.d7b67d07.svg";